<div *ngIf="showSection()" class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div>{{ 'regep.energy-producers-authorization.title' | translate }}</div>
      <div class="section-buttons" *ngIf="sectionButtonsVisible() | async">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div class="form-background margin-align" [ngClass]="{ 'disable-section': getSectionLocked() && applicationId }">
    <div class="top-bottom-margin">
      <div class="info-text">{{ 'regep.energy-producers-authorization.info' | translate }}</div>

      <div class="top-bottom-margin">
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 form-rows">
          <div class="ui-g-4 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-radioButton
              name="is_bafa_auth_granted"
              [value]="true"
              label="{{ 'regep.energy-producers-authorization.bafa-notice-granted' | translate }}"
              [(ngModel)]="regulatoryData.is_bafa_auth_granted"
              (ngModelChange)="bafaNoticeGrantChange($event)"
              #is_bafa_auth_granted="ngModel"
              required
              [disabled]="isSectionDisabled"></p-radioButton>
          </div>
          <div class="ui-g-4 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-radioButton
              name="is_bafa_auth_granted"
              [value]="false"
              label="{{ 'regep.energy-producers-authorization.bafa-notice-will-follow' | translate }}"
              [(ngModel)]="regulatoryData.is_bafa_auth_granted"
              (ngModelChange)="bafaNoticeGrantChange($event)"
              #is_bafa_auth_granted="ngModel"
              required
              [disabled]="isSectionDisabled"></p-radioButton>
          </div>
        </div>

        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
          <div *ngIf="regulatoryData.is_bafa_auth_granted" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mb-3">
            <label class="ui-g-2 field-label text-right-align required">
              {{ 'regep.energy-producers-authorization.bafa-notice-document' | translate }}
            </label>
            <app-file-upload
              [fileData]="regulatoryData.bafa_auth_notice_document"
              [isDetailsView]="isDetailsView && regulatoryData.bafa_auth_notice_document.document_id"
              [type]="regepApplicationDocumentTypes.BafaNoticeOfAuthorization"
              [isClearButtonDisabled]="isSectionDisabled"
              [isRequired]="!isModeratorRole()"
              inputName="BafaNoticeOfAuthorization"
              (clearFileEvent)="clearFile($event)"></app-file-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
